import { render, staticRenderFns } from "./RecommendLab.vue?vue&type=template&id=74702091&scoped=true&"
import script from "./RecommendLab.vue?vue&type=script&lang=js&"
export * from "./RecommendLab.vue?vue&type=script&lang=js&"
import style0 from "./RecommendLab.vue?vue&type=style&index=0&id=74702091&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74702091",
  null
  
)

export default component.exports